import { PxdColumns } from '@app/shared/kendoui/grid/interfaces/pxd-columns';

export const columns: PxdColumns[] = [
  {
    field: 'FormationTopId',
    title: 'Formation Top ID',
    params: {
      lock: false,
      width: 150,
      type: 'numeric',
      display: true,
      editable: false,
      format: '####',
      filter: 'numeric'
    }
  },
  {
    field: 'AreaId',
    title: 'AreaId',
    params: {
      lock: false,
      width: 200,
      type: 'number',
      display: false
    }
  },
  {
    field: 'Area.Description',
    title: 'Area',
    params: {
      lock: false,
      width: 200,
      type: 'dropdownlist',
      display: true,
      defaultItem: {
        name: 'None',
        value: null
      },
      formControl: 'AreaId',
      textField: 'name',
      valueField: 'value',
      data: 'areas',
      viewData: {
        key: 'AreaId',
        func: 'areaMap',
        obj: 'Description'
      }
    }
  },
  {
    field: 'TargetFormationId',
    title: 'TargetFormationId',
    params: {
      lock: false,
      width: 200,
      type: 'number',
      display: false
    }
  },
  {
    field: 'TargetFormation.TargetFormationCommonName.Abbreviation',
    title: 'Target Formation',
    params: {
      lock: false,
      width: 200,
      type: 'dropdownlist',
      display: true,
      defaultItem: {
        name: 'None',
        value: null
      },
      formControl: 'TargetFormationId',
      textField: 'Abbreviation',
      valueField: 'TargetFormationId',
      data: 'targetFormationCommonNamesList',
      viewData: {
        key: 'TargetFormationId',
        func: 'targetFormationCommonNamesMap',
        obj: 'Abbreviation'
      }
    }
  },
  {
    field: 'KBTVD',
    title: 'KBTVD',
    params: {
      lock: false,
      width: 125,
      type: 'numeric',
      display: true,
      editable: true,
      format: 'n6'
    }
  },
  {
    field: 'TreatingPressure',
    title: 'Treating Pressure',
    params: {
      lock: false,
      width: 125,
      type: 'numeric',
      display: true,
      editable: true,
      format: 'n0',
      decimals: 0
    }
  }
];
